/* Shared UI primitives — ported from the approved Stride design. */

/* ---------- Icons (minimal feather-style line art) ---------- */
export const ICONS = {
  home: <><path d="M3 11l9-8 9 8" /><path d="M5 10v10h14V10" /><path d="M9 20v-6h6v6" /></>,
  book: <><path d="M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z" /><path d="M4 5v16" /><path d="M9 7h6M9 11h6" /></>,
  forms: <><path d="M8 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-2" /><rect x="8" y="2" width="8" height="4" rx="1" /><path d="M8 11h8M8 15h5" /></>,
  shield: <><path d="M12 3l8 3v5c0 5-3.4 8.5-8 10-4.6-1.5-8-5-8-10V6z" /><path d="M9 12l2 2 4-4" /></>,
  user: <><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 3.6-6 8-6s8 2 8 6" /></>,
  users: <><circle cx="9" cy="8" r="3.4" /><path d="M2.5 20c0-3.4 2.9-5 6.5-5s6.5 1.6 6.5 5" /><path d="M16 5.2a3.4 3.4 0 0 1 0 6.6M18 20c0-2.6-1-4.2-2.6-5" /></>,
  calendar: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 9h18M8 3v4M16 3v4" /></>,
  search: <><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></>,
  download: <><path d="M12 3v12M7 10l5 5 5-5" /><path d="M4 19h16" /></>,
  external: <><path d="M14 4h6v6" /><path d="M20 4l-9 9" /><path d="M18 13v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6" /></>,
  check: <><path d="M4 12l5 5L20 6" /></>,
  checkCircle: <><circle cx="12" cy="12" r="9" /><path d="M8 12l3 3 5-5" /></>,
  chevronRight: <><path d="M9 6l6 6-6 6" /></>,
  chevronDown: <><path d="M6 9l6 6 6-6" /></>,
  bell: <><path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6" /><path d="M10 20a2 2 0 0 0 4 0" /></>,
  lock: <><rect x="4" y="10" width="16" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /></>,
  plus: <><path d="M12 5v14M5 12h14" /></>,
  gift: <><rect x="3" y="9" width="18" height="12" rx="1" /><path d="M3 13h18M12 9v12" /><path d="M12 9S10.5 3 7.5 4.5 9 9 12 9zM12 9s1.5-6 4.5-4.5S15 9 12 9z" /></>,
  heart: <><path d="M12 20s-7-4.6-9.3-9C1.2 8.3 2.6 5 6 5c2 0 3.2 1.4 4 2.6C10.8 6.4 12 5 14 5c3.4 0 4.8 3.3 3.3 6-2.3 4.4-9.3 9-9.3 9z" /></>,
  sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4 12H2M22 12h-2M5 5l1.5 1.5M17.5 17.5L19 19M19 5l-1.5 1.5M6.5 17.5L5 19" /></>,
  info: <><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></>,
  x: <><path d="M6 6l12 12M18 6L6 18" /></>,
  edit: <><path d="M4 20h4l11-11a2 2 0 0 0-3-3L5 17z" /><path d="M13.5 6.5l3 3" /></>,
  logout: <><path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3" /><path d="M10 12h10M16 8l4 4-4 4" /></>,
  phone: <><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L19 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" transform="translate(-1 0)" /></>,
  mail: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></>,
  calc: <><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M8 7h8M8 12h.01M12 12h.01M16 12h.01M8 16h.01M12 16h.01M16 16h.01" /></>,
  doc: <><path d="M6 2h8l4 4v16H6z" /><path d="M14 2v4h4M9 13h6M9 17h6" /></>,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  pin: <><path d="M12 21s-7-6.3-7-11a7 7 0 0 1 14 0c0 4.7-7 11-7 11z" /><circle cx="12" cy="10" r="2.5" /></>,
  arrowLeft: <><path d="M19 12H5M11 6l-6 6 6 6" /></>,
  swap: <><path d="M7 4L3 8l4 4" /><path d="M3 8h13a4 4 0 0 1 0 8H8" /></>,
  refresh: <><path d="M20 12a8 8 0 1 1-2.3-5.6" /><path d="M20 4v4h-4" /></>,
  menu: <><path d="M4 6h16M4 12h16M4 18h16" /></>,
};

export function Icon({ name, className, style }) {
  return (
    <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke="currentColor"
      strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      {ICONS[name] || ICONS.info}
    </svg>
  );
}

export function IconCircle({ name, size, tone }) {
  const cls = ["icon-circle", size === "lg" ? "lg" : "", tone || ""].filter(Boolean).join(" ");
  return <span className={cls}><Icon name={name} /></span>;
}

/* ---------- Logo / brand mark (official Stride artwork) ---------- */
const BRAND = process.env.PUBLIC_URL + "/brand";
const MARK_SRC = {
  amber: BRAND + "/stride-mark-amber.png",
  orange: BRAND + "/stride_logomark_1200x1200_orange.png",
  brown: BRAND + "/stride_logomark_1200x1200_brown.png",
};
const WORDMARK_SRC = {
  color: BRAND + "/stride-wordmark-color.png",
  white: BRAND + "/stride-wordmark-white.png",
};

export function Mark({ size = 40, variant = "amber" }) {
  // size + radius are caller-driven, so stay inline; static styling is in .brand-img.
  return (
    <img className="brand-img" src={MARK_SRC[variant] || MARK_SRC.amber} alt="Stride Early Learning"
      style={{ width: size, height: size, borderRadius: variant === "amber" ? 0 : Math.round(size * 0.26) }} />
  );
}

export function Logo({ variant = "color", height = 40 }) {
  return (
    <img className="brand-img" src={WORDMARK_SRC[variant] || WORDMARK_SRC.color}
      alt="Stride Early Learning" style={{ height }} />
  );
}

/* ---------- Decorative blob field for dark sections ---------- */
export function BlobField() {
  const shapes = [
    { cls: "blob", c: "var(--orange)", w: 320, h: 300, top: "-90px", left: "-70px", o: 0.5 },
    { cls: "blob-b", c: "var(--amber)", w: 200, h: 220, bottom: "8%", right: "-60px", o: 0.45 },
    { cls: "blob-c", c: "var(--orange)", w: 150, h: 160, bottom: "-50px", left: "22%", o: 0.35 },
  ];
  return (
    <div aria-hidden="true" className="blob-field">
      {shapes.map((s, i) => (
        <div key={i} className={s.cls} style={{
          width: s.w, height: s.h, background: s.c, opacity: s.o,
          top: s.top, left: s.left, right: s.right, bottom: s.bottom,
        }} />
      ))}
    </div>
  );
}

/* ---------- Buttons ---------- */
export function Button({ variant = "primary", size, block, icon, iconRight, className = "", children, ...rest }) {
  const cls = ["btn", `btn-${variant}`, size === "sm" ? "btn-sm" : "", block ? "btn-block" : "", className]
    .filter(Boolean).join(" ");
  return (
    <button className={cls} {...rest}>
      {icon && <Icon name={icon} className="ico-16" />}
      {children}
      {iconRight && <Icon name={iconRight} className="ico-16" />}
    </button>
  );
}

/* ---------- Toggle ---------- */
export function Toggle({ on, onClick, small }) {
  return (
    <button type="button" className={"toggle" + (on ? " on" : "") + (small ? " sm" : "")} onClick={onClick} aria-pressed={on}>
      <span className="toggle-knob" />
    </button>
  );
}

/* ---------- Child avatar ---------- */
export const AVATAR_PALETTE = ["var(--orange)", "var(--amber)", "#7BA05B", "#5B8BA0"];

export function ChildAvatar({ c, size = 46 }) {
  const color = c.color || AVATAR_PALETTE[(c.index || 0) % AVATAR_PALETTE.length];
  const onAmber = color === "var(--amber)";
  // width/height/background/colour/font-size are data-driven, so stay inline;
  // all static styling lives in the .avatar class.
  return (
    <span className="avatar" style={{
      width: size, height: size, background: color,
      color: onAmber ? "var(--brown)" : "#fff", fontSize: size * 0.42,
    }}>{(c.name || "?")[0]}</span>
  );
}
